import { GetStripeIntegration } from '@/connection/integrations/stripe';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const fetchStripeIntegrationReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async (_, { rejectWithValue }) => {
      try {
        const stripeIntegration = await GetStripeIntegration();
        return stripeIntegration;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.stripe = {
          ...state.stripe,
          status: action.payload.stripe_status,
          contact: action.payload.primary_contact,
        };
      },
    }
  );
};

export default fetchStripeIntegrationReducer;
